import { render, staticRenderFns } from "./leftBar.vue?vue&type=template&id=687155ba&scoped=true&"
import script from "./leftBar.vue?vue&type=script&lang=js&"
export * from "./leftBar.vue?vue&type=script&lang=js&"
import style0 from "./leftBar.vue?vue&type=style&index=0&id=687155ba&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687155ba",
  null
  
)

export default component.exports